import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import { Grid, Avatar, Typography } from '@material-ui/core';
import classNames from 'classnames';
import isEmpty from 'lodash/isEmpty';
import isObject from 'lodash/isObject';
import { ADGMItemDetails } from 'aurora-components';
import { keyEmptyCheck } from 'aurora-utils/utils';
import TenantProfile from 'aurora-images/user_profile.svg';
import UserProfileV3 from 'aurora-images/user_profileV3.svg';
import styles from './styles';

const ADGMGridLayout = ({
  classes,
  data,
  nameTitle,
  withImage,
  withImageV2,
  defaultValue,
  hasPadding,
  customClasses,
  ...gridProps
}) => {
  if (!isObject(data) || isEmpty(data)) return null;
  const locale = localStorage.getItem('lang');

  const { ownerNameEn, ownerNameAr, numberInList, ...dataWithoutNames } = data;

  return (
    <Grid
      container
      spacing={2}
      className={classNames(classes.container, customClasses?.container, {
        [classes.containerPadding]: hasPadding,
      })}
    >
      {withImage && (
        <Grid item md={4} xs={12}>
          <Avatar alt='avatar' src={TenantProfile} className={classes.Avatarimg} />
          <Typography variant='subtitle1' className={classes.nameTitle}>
            {keyEmptyCheck(nameTitle)}
          </Typography>
          {locale && locale === 'ar' ? (
            <Typography variant='subtitle1' className={classes.strongText}>
              {ownerNameAr}
            </Typography>
          ) : (
            <Typography variant='subtitle1' className={classes.strongText}>
              {ownerNameEn}
            </Typography>
          )}
        </Grid>
      )}

      {withImageV2 && (
        <Grid className={classes.avatarV2Container} item md={4} sm={12}>
          <Avatar alt='avatar' src={UserProfileV3} className={classes.Avatarimg} />
          <div className={classes.nameContainer}>
            <Typography variant='subtitle1' className={classes.nameTitle}>
              {numberInList ? keyEmptyCheck('owner_num', { s: numberInList }) : keyEmptyCheck(nameTitle)}
            </Typography>
            {locale && locale === 'ar' ? (
              <Typography variant='subtitle1' className={classes.strongText}>
                {ownerNameAr}
              </Typography>
            ) : (
              <Typography variant='subtitle1' className={classes.strongText}>
                {ownerNameEn}
              </Typography>
            )}
          </div>
        </Grid>
      )}

      <Grid item container md={withImage || withImageV2 ? 8 : 12} sm={12} spacing={2}>
        {Object.keys(dataWithoutNames)?.map(key =>
          !key && !data[key] ? null : (
            <Grid
              key={key}
              item
              md={4}
              sm={4}
              {...gridProps}
              className={classNames(classes.itemContainer, customClasses?.itemContainer)}
            >
              <ADGMItemDetails label={key} value={data[key] || defaultValue} />
            </Grid>
          ),
        )}
      </Grid>
    </Grid>
  );
};

ADGMGridLayout.propTypes = {
  classes: PropTypes.object.isRequired,
  data: PropTypes.object.isRequired,
  hasPadding: PropTypes.bool,
  defaultValue: PropTypes.any,
  customClasses: PropTypes.object,
  withImage: PropTypes.bool,
  withImageV2: PropTypes.bool,
  nameTitle: PropTypes.any,
};

ADGMGridLayout.defaultProps = {
  hasPadding: false,
  customClasses: {},
  defaultValue: null,
  withImage: false,
  withImageV2: false,
  nameTitle: 'Name',
};

export default withStyles(styles)(ADGMGridLayout);
